import script from "./BulkAddCallersDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./BulkAddCallersDialog.vue?vue&type=script&setup=true&lang=js"

import "./BulkAddCallersDialog.vue?vue&type=style&index=0&id=862cabae&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-862cabae"]])

export default __exports__